import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import RepairHistoryView from "../views/RepairHistoryView"
import EExpertView from "../views/EExpertView"

const Sidebar = ({
  repairHistory,
  loading,
  showEExpert,
  repairId,
  onCloseEExpert,
  sessionId,
  appLookups,
  onFileUpload,
  refreshRepairDetails,
  isDynamic,
  setLoading
}) => {
  const location = useLocation()
  const [isFullscreen, setIsFullscreen] = useState(false)
  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth > 1200)

  // Check window width on mount and resize
  useEffect(() => {
    const handleResize = () => {
      const wideScreen = window.innerWidth > 1200
      setIsWideScreen(wideScreen)

      // Reset fullscreen state when going to wide screen
      if (wideScreen && isFullscreen) {
        setIsFullscreen(false)
      }
    }

    // Set initial value
    handleResize()

    // Add resize listener
    window.addEventListener("resize", handleResize)

    // Clean up
    return () => window.removeEventListener("resize", handleResize)
  }, [isFullscreen])

  // Toggle fullscreen state
  const toggleFullscreen = () => {
    setIsFullscreen(!isFullscreen)
  }

  // Determine which component to render based on the route
  const renderContent = () => {
    // If we're showing e-expert iframe
    if (showEExpert && repairId) {
      return (
        <EExpertView
          repairId={repairId}
          sessionId={sessionId}
          onClose={onCloseEExpert}
          appLookups={appLookups}
          onFileUpload={onFileUpload}
          refreshRepairDetails={refreshRepairDetails}
          isDynamic={isDynamic}
          setLoading={setLoading}
        />
      )
    }
    // Check if we're on an repair details page
    else if (location.pathname.includes("/repairs/") && !location.pathname.endsWith("/repairs/")) {
      return <RepairHistoryView history={repairHistory} loading={loading} />
    }

    // Default to empty view
    return <></>
  }

  return (
    <div className={`sidebar h-100 overflow-auto ${isFullscreen ? "sidebar-fullscreen" : ""}`}>
      {!isWideScreen && (
        <button
          className="btn btn-sm fullscreen-toggle"
          onClick={toggleFullscreen}
          aria-label={isFullscreen ? "Minimize sidebar" : "Maximize sidebar"}>
          <i className={`fa ${isFullscreen ? "fa-arrow-down" : "fa-arrow-up"}`}></i>
        </button>
      )}
      {renderContent()}
    </div>
  )
}

export default Sidebar
